<template>
  <b-form-group
    :label="item.title"
    :description="item.helpText"
    label-class="mb-0 pb-0 label-title"
  >
    <Datepicker
      :input-class="{ saving: saving, saved: saved }"
      v-model="dateValue"
      :disabled-dates="disabledDates"
      :bootstrap-styling="true"
      :clear-button="true"
      :format="dateFormat"
      @selected="userHasInteracted = true"
      @cleared="userHasInteracted = true"
      @input="userHasInteracted = true"
    />
  </b-form-group>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import FormItem from "./FormItem";
import { debounce } from "lodash";
import { EventBus } from "../../event-bus";

export default {
  name: "DateFormItem",
  extends: FormItem,
  props: ["item"],
  data: function () {
    return {
      dateFormat: "dd/MM/yyyy",
      dateValue: null,
      saving: false,
      saved: false,
      userHasInteracted: false,
    };
  },
  created() {
    // Create the debounced function once during component creation
    this.debouncedSave = debounce(() => {
      this.saved = true;
      this.saving = false;
      setTimeout(() => {
        this.saved = false;
      }, 1000);
    }, 1000);

    this.setDate();
  },
  methods: {
    setDate: function () {
      if (
        this.item.value != null &&
        this.item.value !== "" &&
        this.item.value.length === 10
      ) {
        this.dateValue = this.moment(this.item.value, "YYYY-MM-DD").toDate();
      }
    },
  },
  watch: {
    dateValue: function (newValue) {
      if (newValue) {
        this.item.value = this.moment(newValue).format("YYYY-MM-DD");
        // Only trigger auto-save if user has interacted with the component
        if (this.userHasInteracted) {
          this.saving = true;
          this.saved = false;
          EventBus.$emit("form-saving-started");
          this.debouncedSave();
        }
      }
    },
    item: {
      immediate: true,
      deep: true,
      handler(val, oldVal) {
        this.setDate();
      },
    },
  },
  computed: {
    disabledDates() {
      if (this.item.identifier === "DiaryReminderDate") {
        return { to: this.moment().toDate() };
      }
    },
  },
  components: { Datepicker },
};
</script>

<style scoped>
label,
legend.col-form-label {
  font-weight: bold;
}
</style>
